import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import { getDefaultAlertProps } from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import { IAlertProps } from '../../interface/IAlertProps';
import { MAIN_COLOR_STRING } from '../../constant/constants';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { IApiResult } from '../../interface/IApiResult';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { FactoryBodyHeaderDiv } from '../body-header/FactoryBodyHeaderDiv';
import { MyTextFiled } from '../UI/MyTextField';
import { MyButton } from '../UI/MyButton';
import { GeneratePasswordDto } from '../../dto/GeneratePasswordDto';
import { apiGetGeneratePasssword } from '../../service/service/apiGetGeneratePasssword';

export const GeneratePasswordsDiv = () => {
  const { t } = useTranslation();
  const [backDrop, setBackDrop] = useState(false);
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );

  const [textSet, setText] = useState<GeneratePasswordDto>({
    text: '',
    man: '',
    sc: '',
  });

  const [textSet2, setText2] = useState<GeneratePasswordDto>({
    text: '',
    man: '',
    sc: '',
  });

  const generateParolNewNew = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetGeneratePasssword(textSet);
    if (apiResult.isSuccess) {
      setText2(apiResult.data);
    } else {
      setAlertProps({
        message: t('errotServer'),
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <BackDropDiv open={backDrop} />
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <Stack width="100%" alignItems="center" marginBottom="20px" spacing={2}>
        <Stack width="90%">
          <FactoryBodyHeaderDiv title={t('generatePassword')} />
        </Stack>
        <Stack width="90%" spacing={1}>
          <Stack direction="row" spacing={1}>
            <MyButton
              text={t('generate')}
              background={MAIN_COLOR_STRING}
              onClick={generateParolNewNew}
            />
            <MyTextFiled
              value={textSet2.sc}
              type="text"
              label={t('sc')}
              size="small"
            />
            <MyTextFiled
              value={textSet2.man}
              type="text"
              label={t('man')}
              size="small"
            />
          </Stack>
          <MyTextFiled
            value={textSet.text?.replaceAll('****', '\n')}
            onChange={(e) =>
              setText({
                ...textSet,
                text: e.target.value.replaceAll('\n', '****'),
              })
            }
            type="text"
            multiLine
            label={t('stats')}
            size="small"
          />
        </Stack>
      </Stack>
    </div>
  );
};
